import React,{ useState } from 'react';
import './App.css';
import Alert from './components/Alert';
// import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
function App() {
  const [mode, setMode] = useState('light'); //Whether dark mode is enabled or not
  const [btnlbl, setbtnlbl] = useState('Dark');
  const [alert, setAlert] = useState(null);
  const showAlert = (message,type)=>{
    setAlert({
      msg:message,
      type:type
    })
    setTimeout(()=>{
      setAlert(null);
    },2000);
  }
  let togglemode=()=>{
    if(mode==='light')
    {
      setMode('dark');
      setbtnlbl('Light');
      document.body.style.backgroundColor = '#042743';
      showAlert("Dark mode has been enabled","success");
      document.title='TextUtils - DarkMode';
    }
    else
    {
      setMode('light');
      setbtnlbl('Dark');
      document.body.style.backgroundColor = 'white';
      showAlert("Light mode has been enabled","success");
      document.title='TextUtils - LightMode';
    }
  }
  return (
    <>
      {/* <Navbar title="TextUtils" aboutText="About TextUtils"/> */}
      {/* <Router> */}
      <Navbar title="TextUtils" mode ={mode} toggleMode={togglemode} SwitchLabel={btnlbl}/>
      <Alert alert={alert}></Alert>
      <div className='container my-3'>
        {/* <Routes> */}
        {/* <Route exact path='/' element={<TextForm heading="Enter the text to analyze" mode={mode} showAlert={showAlert}/>}> */}
        <TextForm heading="Enter the text to analyze" mode={mode} showAlert={showAlert}/>
          {/* </Route>
          <Route exact path='/about' element={<About/>}> */}
          {/* </Route>
        </Routes> */}
      </div>
      {/* </Router> */}
    </>
  );
}

export default App;
